/*
 *in this module there are all the functions to create
 *  - the popup for AM
 *  - hover popup
 *  - display the correct popup (AM, AM PLUS)
 */

 import functions from '../common/functions'

 var pageconfig = JSON.parse($('#pageconfig').val())
 let popupconfig = JSON.parse($('#popupconfig').val())
 let appname = pageconfig.appname.type
 var layerinfo = functions.altFind(pageconfig.layers, function(e) {return e.layers === "accsmap"})

/**
 * build the popup content
 * we need to pass  getSettings, xml, mousePos
 */
const fullInfo = (xml, mousePos, getOverlay) => {
  if (appname = 'accsmap' && (pageconfig.private)) {
    accspopupplus(xml, mousePos, getOverlay)
  } else {
    accspopup(xml, mousePos, getOverlay)
  }
}
const accspopup = (xml, mousePos, getOverlay) => {
  /**
   * assign the popupname value
   * assign the overlay value
   */

   let popupname = layerinfo.popupname
   let overlay = getOverlay

   /**
    * get the result from the XML
    * - create a parser
    * - parse the result
    * - get the item element
    * - get the length of the item element
    */

    let myitems = xml.getElementsByTagName('item')
    let myitemsLength = myitems.length
    $('#popup').removeClass('pluspop')
  /**
   * initilaize some variable to use it in the process
   */

  let conterz = ''
  let infolink = ''
  let infoDiv = ''

  /**
   * get the popup container
   *  - normal popup
   *  - mobile popup
   */

  let content = document.getElementById('popup-content')
  let modalpop = document.getElementById('mobpopupbody')

  /**
   * create the popup content
   */

  /**
   * essex popup
   */

  if (popupname === 'essex') {
    /**
     * iterate through the result
     */

    for (let i = 0; i <= (myitemsLength - 1); i++) {
      /**
       * check if the node is site
       */

      if (myitems[i].attributes.getNamedItem('type').nodeValue === 'site') {
        /**
         * check if the length of the result is more than 1
         */

        if (myitemsLength > 1) {
          /**
           * add the site name to infolink
           * this will be use in the list that display all the selected restrictions
           */

          infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${popupconfig.accsmap_popup.site}${functions.getFieldValue(myitems, i, 'name')}</li>`
        }

        /**
         * append the name and the cam_dist field
         * append the dftsiteid field
         */

        conterz += `<div><span class='infotitle'>${functions.getFieldValue(myitems, i, 'sitename')}, ${functions.getFieldValue(myitems, i, 'cam_dist')}</span></div>`
        conterz += `<div><span class='infotitle'>${popupconfig.accsmap_popup.siteid}</span><span>${functions.getFieldValue(myitems, i, 'dftsiteid')}</span></div>`

        /**
         * append the infotab div
         * append a spacer div
         */

        conterz += `<div id='infotab'>`
        conterz += `<div class='spacer'></div>`

        /**
         * append the table with:
         * Date Range
         * KSI
         * PIC
         */

        conterz += `<table class='estab'><tr><th class='estableft'>Date Range</th><th>${popupconfig.accsmap_popup.ksi}</th><th>${popupconfig.accsmap_popup.pic}</th></tr><tr>`
        conterz += `<td class='estableft'><time>${functions.getFieldValue(myitems, i, 'wfsbef')}</time> to <time>${functions.getFieldValue(myitems, i, 'wfsend')}</time></td>`
        conterz += `<td>${functions.getFieldValue(myitems, i, 'ksi')}</td>`
        conterz += `<td>${functions.getFieldValue(myitems, i, 'pic')}</td></tr></table>`
        conterz += `<div class='spacer'></div>`
        conterz += `</div>`

        /**
         * append the Data correct at time of publication (date) text
         */

        conterz += `<div><span>${popupconfig.accsmap_popup.datastate} ${functions.getPublishDate('accsmap').split('-').reverse().join('/')}</span></div>`
      }

      /**
       * check if the node is site
       */

      else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'camera') {
        /**
         * check if the length of the result is more than 1
         */

        if (myitemsLength > 1) {
          infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${popupconfig.accsmap_popup.camera} ${functions.getFieldValue(myitems, i, 'name')}</li>`
        }

        /**
         * append the accident anme and the cam_dist field
         * append the type field
         */

        conterz += `<div><span class='infotitle'>${functions.getFieldValue(myitems, i, 'sitename')}, ${functions.getFieldValue(myitems, i, 'cam_dist')}</span></div>`
        conterz += `<div><span class='infotitle'>${popupconfig.accsmap_popup.equipment}</span><span>${functions.getFieldValue(myitems, i, 'type')}</span></div>`

        /**
         * append the Data correct at time of publication (date) text
         */

        conterz += `<div><span>${popupconfig.accsmap_popup.datastate} ${functions.getPublishDate('accsmap').split('-').reverse().join('/')}</span></div>`
      }

      /**
       * check if the node is route
       */

      else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'route') {
        /**
         * check if the length of the result is more than 1
         */

        if (myitemsLength > 1) {
          /**
           * add the restriction name to infolink
           * this will be use in the list that display all the selected restrictions
           */

          infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${popupconfig.accsmap_popup.route}${functions.getFieldValue(myitems, i, 'name')}</li>`
        }

        /**
         * append the accident anme and the cam_dist field
         * append the type field
         */

        conterz += `<div><span>${popupconfig.accsmap_popup.route}${functions.getFieldValue(myitems, i, 'name')}</span></div>`
        conterz += `<div><span>${popupconfig.accsmap_popup.routetype}${functions.getFieldValue(myitems, i, 'tms')}</span></div>`
        conterz += `<div><span class='infotitle'> ${functions.getFieldValue(myitems, i, 'desc')}:</span></div>`

        /**
         * append the Data correct at time of publication (date) text
         */

        conterz += `<div><span>${popupconfig.accsmap_popup.datastate} ${functions.getPublishDate('accsmap').split('-').reverse().join('/')}</span></div>`
      }

      /**
       * else if it's an accident type
       */

      else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'accident') {
        /**
         * check if the length of the result is more than 1
         */

        if (myitemsLength > 1) {
          /**
           * add the accmonth accyear severity fiedds to infolink
           * this will be use in the list that display all the selected restrictions
           */

          infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'accmonth')} ${functions.getFieldValue(myitems, i, 'accyear')}: ${functions.getFieldValue(myitems, i, 'severity')}</li>`
        }

        /**
         * create an hidden input and store the police_ref
         * append the severity field plus the collision details text
         * append the police_ref field
         * append the accday accmonth accyear and acctime
         */

        conterz += `<input id='policeref_${i}' type='hidden' value='${functions.getFieldValue(myitems, i, 'police_ref')}' />`

        conterz += `<div><span class='infotitle'>${functions.getFieldValue(myitems, i, 'severity')} ${popupconfig.accsmap_popup.collisiondetails} </span>`
        conterz += `<span id='police_ref_" + i + "'>${functions.getFieldValue(myitems, i, 'police_ref')}</span>`
        conterz += ` - <time>${functions.getFieldValue(myitems, i, 'accday')} ${functions.getFieldValue(myitems, i, 'accmonth')} ${functions.getFieldValue(myitems, i, 'accyear')}</time>`
        conterz += `- <time>${functions.getFieldValue(myitems, i, 'acctime')}`
        conterz += `</time></div>`

        /**
         * append the infotab div
         * append a spacer dive
         */

        conterz += `<div id='infotab'>`
        conterz += `<div class='spacer'></div>`

        /**
         * append the table with:
         * Vehs
         * Cas
         * Peds
         * Child
         * Cycles
         * OAPs
         */

        conterz += `<table class='estabacc'><tr><th>${popupconfig.accsmap_popup.vehs}</th><th>${popupconfig.accsmap_popup.cas}</th><th>${popupconfig.accsmap_popup.peds}</th><th>${popupconfig.accsmap_popup.child}</th><th>${popupconfig.accsmap_popup.cycles}</th><th>${popupconfig.accsmap_popup.oaps}</th></tr><tr>`
        conterz += `<td>${functions.getFieldValue(myitems, i, 'vehicles')}</td>`
        conterz += `<td>${functions.getFieldValue(myitems, i, 'casualties')}</td>`
        conterz += `<td>${functions.getFieldValue(myitems, i, 'pedestrian')}</td>`
        conterz += `<td>${functions.getFieldValue(myitems, i, 'children')}</td>`
        conterz += `<td>${functions.getFieldValue(myitems, i, 'cycles')}</td>`
        conterz += `<td>${functions.getFieldValue(myitems, i, 'oaps')}</td></tr></table>`
        conterz += `<div class='spacer'></div>`
        conterz += `</div>`

        /**
         * append the location
         */

        conterz += `<div><span class='infotitle'>${popupconfig.accsmap_popup.location}:</span></div>`
        conterz += `<div><span>${functions.getFieldValue(myitems, i, 'acclocation')}</span></div>`

        /**
         * append the Data correct at time of publication (date) text
         */

        conterz += `<div><span>${popupconfig.accsmap_popup.datastate} ${functions.getPublishDate('accsmap').split('-').reverse().join('/')}</span></div>`

      /**
       * end else if it's an accident type
       */
      }

      /**
       * copy button
       */

      conterz += `<button id='Copy_Btn_${i}' class='Copy_Btn btn mt-1 fas fa-clipboard' style='width:auto;' data-toggle="tooltip" data-container="#Copy_Btn_${i}" data-placement="top" title="${popupconfig.copystate}"></button>`

      /**
       * check if is the first iteration, first result or not
       * append the correct div to the popup content
       */

      if (i === 0) {
        infoDiv = infoDiv + `<div  id='info_${i}'>${conterz}</div>`
      }
      else {
        infoDiv = infoDiv + `<div id='info_${i}' style='display:none;'>${conterz}</div>`
      }
      /**
       * reset the conterz var as now is inside the infoDiv var
       */
      conterz = ''
    } // next feature

    /**
     * end essex popup
     */
  }

  /**
   * tvp hampshire popup
   */

  else if (popupname === 'tvp') {
    /**
     * iterate through the result
     */

    for (let i = 0; i <= (myitemsLength - 1); i++) {
      /**
       * check if the node is site
       */

      if (myitems[i].attributes.getNamedItem('type').nodeValue === 'site') {
        /**
         * check if the length of the result is more than 1
         */

        if (myitemsLength > 1) {
          /**
           * add the site name and site type to infolink
           * this will be use in the list that display all the selected restrictions
           */

          infolink = infolink + `<li value='$[i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'sitename')}: ${functions.getFieldValue(myitems, i, 'sitetype')}</li>`
        }
        conterz += `<div><span class='infotitle'>${functions.getFieldValue(myitems, i, 'sitetype')}${popupconfig.accsmap_popup.sitedetails}</span>`
        conterz += `<span>${functions.getFieldValue(myitems, i, 'sitename')}</span></div>`

        /**
         * append the infotab div
         * append a spacer dive
         */

        conterz += `<div id='infotab'>`
        conterz += `<div class='spacer'></div>`

        /**
         * append the table with:
         * Total
         * Collisions
         * casualties
         * Offence
         */

        conterz += `<table class='tvptab'><tr><th class='tvptableft'>${popupconfig.accsmap_popup.total}</th>`
        conterz += `<th>${functions.getFieldValue(myitems, i, 'year1')}</th><th>${functions.getFieldValue(myitems, i, 'year2')}</th><th>${functions.getFieldValue(myitems, i, 'year3')}</th>`
        conterz += `<th>${functions.getFieldValue(myitems, i, 'year4')}</th><th>${functions.getFieldValue(myitems, i, 'year5')}</th><th>${functions.getFieldValue(myitems, i, 'year6')}*</th>`
        conterz += `</tr>`

        conterz += `<tr><td class='tvptableft'>${popupconfig.accsmap_popup.collisions}</td>`
        conterz += `<td>${functions.getTabValue(myitems, i, 'totaccs1')}</td><td>${functions.getTabValue(myitems, i, 'totaccs2')}</td><td>${functions.getTabValue(myitems, i, 'totaccs3')}</td>`
        conterz += `<td>${functions.getTabValue(myitems, i, 'totaccs4')}</td><td>${functions.getTabValue(myitems, i, 'totaccs5')}</td><td>${functions.getTabValue(myitems, i, 'totaccs6')}</td>`
        conterz += `</tr>`

        conterz += `<tr><td class='tvptableft'>${popupconfig.accsmap_popup.casualties}</td>`
        conterz += `<td>${functions.getTabValue(myitems, i, 'totcas1')}</td><td>${functions.getTabValue(myitems, i, 'totcas2')}</td><td>${functions.getTabValue(myitems, i, 'totcas3')}</td>`
        conterz += `<td>${functions.getTabValue(myitems, i, 'totcas4')}</td><td>${functions.getTabValue(myitems, i, 'totcas5')}</td><td>${functions.getTabValue(myitems, i, 'totcas6')}</td>`

        conterz += `<tr><td class='tvptableft'>${popupconfig.accsmap_popup.offence}</td>`
        conterz += `<td>${functions.getTabValue(myitems, i, 'totoff1')}</td><td>${functions.getTabValue(myitems, i, 'totoff2')}</td><td>${functions.getTabValue(myitems, i, 'totoff3')}</td>`
        conterz += `<td>${functions.getTabValue(myitems, i, 'totoff4')}</td><td>${functions.getTabValue(myitems, i, 'totoff5')}</td><td>${functions.getTabValue(myitems, i, 'totoff6')}</td>`
        conterz += `</tr>`
        conterz += `</table>`

        conterz += `</div>`

        /**
         * append a spacer dive
         */

        conterz += `<div class='spacer'></div>`

        /**
         * append means of * in the table
         * append data correct at time of publication text
         */
        conterz += `<div><span>${popupconfig.accsmap_popup.incompleteyear}</span></div>`
        conterz += `<div><span>${popupconfig.accsmap_popup.datastate}</span></div>`
      }

      /**
       * else if it's an accident type
       */

      else {
        /**
         * check if the length of the result is more than 1
         */

        if (myitemsLength > 1) {
          /**
           * add the accmont accyear and severity to infolink
           * this will be use in the list that display all the selected restrictions
           */

          infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'accmonth')} ${functions.getFieldValue(myitems, i, 'accyear')}: ${functions.getFieldValue(myitems, i, 'severity')}</li>`
        }

        /**
         * append the severity and accident details text
         * append the police_ref field
         * append the accday accmonth accyear and acctime
         */

        conterz += `<div><span class='infotitle'>${functions.getFieldValue(myitems, i, 'severity')} ${popupconfig.accsmap_popup.accidentdetails} </span>`
        conterz += `<span>${functions.getFieldValue(myitems, i, 'police_ref')}</span></div>`
        conterz += `<div><time>${functions.getFieldValue(myitems, i, 'accday')} ${functions.getFieldValue(myitems, i, 'accmonth')} ${functions.getFieldValue(myitems, i, 'accyear')}</time> <time>${functions.getFieldValue(myitems, i, 'acctime')}</time></div>`

        /**
         * append the infotab div
         * append a spacer dive
         */

        conterz += `<div id='infotab'>`
        conterz += `<div class='spacer'></div>`

        /**
         * append the table with:
         * Vehs
         * Cas
         * Peds
         * Child
         * Cycles
         * OAPs
         */

        conterz += `<table class='tvptabacc'>`
        conterz += `<tr><th>${popupconfig.accsmap_popup.vehs}</th><th>${popupconfig.accsmap_popup.cas}</th><th>${popupconfig.accsmap_popup.peds}</th><th>${popupconfig.accsmap_popup.child}</th><th>${popupconfig.accsmap_popup.cycles}</th><th>${popupconfig.accsmap_popup.oaps}</th></tr><tr>`
        conterz += `<td>${functions.getFieldValue(myitems, i, 'vehicles')}</td>`
        conterz += `<td>${functions.getFieldValue(myitems, i, 'casualties')}</td>`
        conterz += `<td>${functions.getFieldValue(myitems, i, 'pedestrian')}</td>`
        conterz += `<td>${functions.getFieldValue(myitems, i, 'children')}</td>`
        conterz += `<td>${functions.getFieldValue(myitems, i, 'cycles')}</td>`
        conterz += `<td>${functions.getFieldValue(myitems, i, 'oaps')}</td>`
        conterz += `</tr></table>`

        /**
         * append a spacer dive
         */

        conterz += `<div class='spacer'></div>`
        conterz += `</div>`

        /**
         * append location
         * append the data correct at time of pubblication
         */

        conterz += `<div><span class='infotitle'>${popupconfig.accsmap_popup.location}</span></div>`
        conterz += `<div><span>${functions.getFieldValue(myitems, i, 'acclocation')}</span></div>`
        conterz += `<div><span>${popupconfig.accsmap_popup.datastate}</span></div>`

      /**
       * end else if it's an accident type
       */
      }

      /**
       * copy button
       */

      conterz += `<button id='Copy_Btn_${i}' class='Copy_Btn btn mt-1 fas fa-clipboard' style='width:auto;' data-toggle="tooltip" data-container="#Copy_Btn_${i}" data-placement="top" title="${popupconfig.copystate}"></button>`

      /**
       * check if is the first iteration, first result or not
       * append the correct div to the popup content
       */

      if (i === 0) {
        infoDiv = infoDiv + `<div id='info_${i}'>${conterz}</div>`
      }
      else {
        infoDiv = infoDiv + `<div id='info_${i}' style='display:none;'>${conterz}</div>`
      }

      /**
       * reset the conterz var as now is inside the infoDiv var
       */
      conterz = ''
    } // next feature

    /**
     * end tvp hampshire popup
     */
  }

  /**
   * standard popup
   */

  else {
    /**
     * iterate through the result
     */

    for (let i = 0; i <= (myitemsLength - 1); i++) {
      /**
       * check if the node is site
       */

      if (myitems[i].attributes.getNamedItem('type').nodeValue === 'site') {
        /**
         * check if the length of the result is more than 1
         */

        if (myitemsLength > 1) {
          /**
           * add the site name and site type to infolink
           * this will be use in the list that display all the selected restrictions
           */

          infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${popupconfig.accsmap_popup.site} ${functions.getFieldValue(myitems, i, 'sitename')}</li>`
        }

        /**
         * append the sitename and cam_dist field
         * append the equipment text an the site type
         * append data correct at time of pubblication (date) text
         */

        conterz += `<div><span class='infotitle'>${functions.getFieldValue(myitems, i, 'sitename')}, ${functions.getFieldValue(myitems, i, 'cam_dist')}</span></div>`
        conterz += `<div><span class='infotitle'>${popupconfig.accsmap_popup.equipment} </span><span>${functions.getFieldValue(myitems, i, 'type')}</span></div>`
        conterz += `<div><span>${popupconfig.accsmap_popup.datastate} <time>${functions.getPublishDate('accsmap').split('-').reverse().join('/')}<time></span></div>`
      }

      /**
       * check if the node is camera
       */

      else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'camera') {
        /**
         * check if the length of the result is more than 1
         */

        if (myitemsLength > 1) {
          /**
           * add the site name to infolink
           * this will be use in the list that display all the selected restrictions
           */

          infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${popupconfig.accsmap_popup.camera}${functions.getFieldValue(myitems, i, 'sitename')}</li>`
        }

        /**
         * append the sitename and cam_dist field
         * append the equipment text an the site type
         * append data correct at time of pubblication(date) text
         */

        conterz += `<div><span class='infotitle'>${functions.getFieldValue(myitems, i, 'sitename')}, ${functions.getFieldValue(myitems, i, 'cam_dist')}</span></div>`
        conterz += `<div><span class='infotitle'>${popupconfig.accsmap_popup.equipment} </span><span>${functions.getFieldValue(myitems, i, 'type')}</span></div>`
        conterz += `<div><span>${popupconfig.accsmap_popup.datastate} <time>${functions.getPublishDate('accsmap').split('-').reverse().join('/')}<time></span></div>`
      }

      /**
       * else if it's an accident type
       */

      else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'accident') {
        /**
         * check if the length of the result is more than 1
         */
        if (myitemsLength > 1) {
          /**
           * add the accmont accyear and severity to infolink
           * this will be use in the list that display all the selected restrictions
           */

          infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'accmonth')} ${functions.getFieldValue(myitems, i, 'accyear')}: ${functions.getFieldValue(myitems, i, 'severity')}</li>`
        }
        /**
         * add an hidden input with the police_ref field
         * append the severity field and the accident details text
         * append the accday accmonth accyear field
         */
        if (popupname === 'devon') {
            //add local auth code
            conterz += `<div><span class='infotitle'>Local Authority Area:</span></div>`
           if (functions.getFieldValue(myitems, i, 'local_auth') == 'TORBAY') {
                conterz += `<div><a href="https://www.torbay.gov.uk/roads/road-safety/" style="width: 109px;" aria-label="Click to navigate to Torbay Council"><img class="la-link-logo" src="${$('#docstore').val()}/custom/assets/torbay.png" alt="Torbay logo"></a></div>`
                //conterz += `<div><a class='lalink' target='_blank' rel='noopener noreferrer' href='https://www.torbay.gov.uk/roads/road-safety/'>Torbay Council</a></div>`
            } else if (functions.getFieldValue(myitems, i, 'local_auth') == 'PLYMOUTH') {
                conterz += `<div><a href="https://www.plymouth.gov.uk/road-safety" style="width: 109px;" aria-label="Click to navigate to Plymouth City Council"><img class="la-link-logo" src="${$('#docstore').val()}/custom/assets/plymouth.png" alt="Plymouth logo"></a></div>`
                //conterz += `<div><a class='lalink' target='_blank' rel='noopener noreferrer' href='https://www.plymouth.gov.uk/road-safety'>Plymouth City Council</a></div>`
            } else if (functions.getFieldValue(myitems, i, 'local_auth') == 'CORNWALL') {
                conterz += `<div><a href="https://www.cornwall.gov.uk/fire-and-rescue-service/keeping-safe/road-safety/" style="width: 150px;" aria-label="Click to navigate to Cornwall County Council"><img class="la-link-logo" src="${$('#docstore').val()}/custom/assets/cornwall.png" alt="Cornwall logo"></a></div>`
                //conterz += `<div><a class='lalink' target='_blank' rel='noopener noreferrer' href='https://www.cornwall.gov.uk/fire-and-rescue-service/keeping-safe/road-safety/'>Cornwall County Council</a></div>`
            } else if (functions.getFieldValue(myitems, i, 'local_auth') == 'NH') {
                conterz += `<div><a href="https://nationalhighways.co.uk/road-safety/" style="width: 150px;" aria-label="Click to navigate to Cornwall County Council"><img class="la-link-logo" src="${$('#docstore').val()}/custom/assets/nh.png" alt="National Highways logo"></a></div>`
                //conterz += `<div><a class='lalink' target='_blank' rel='noopener noreferrer' href='https://www.cornwall.gov.uk/fire-and-rescue-service/keeping-safe/road-safety/'>Cornwall County Council</a></div>`

            } else {
                conterz += `<div><a href="https://www.devon.gov.uk/roadsandtransport/" style="width: 150px;" aria-label="Click to navigate to Devon County Council"><img class="la-link-logo" src="${$('#docstore').val()}/custom/assets/devon.png" alt="Devon logo"></a></div>`
                //conterz += `<div><a class='lalink' target='_blank' rel='noopener noreferrer' href='https://www.devon.gov.uk/roadsandtransport/'>Devon County Council</a></div>`
            }
        }
        conterz += `<input id='policeref_${i}' type='hidden' value='${functions.getFieldValue(myitems, i, 'police_ref')}' />`
        conterz += `<div><span class='infotitle'>${functions.getFieldValue(myitems, i, 'severity')} ${popupconfig.accsmap_popup.accidentdetails}</span></div>`
        conterz += `<div><span>${functions.getFieldValue(myitems, i, 'accday')} ${functions.getFieldValue(myitems, i, 'accmonth')} ${functions.getFieldValue(myitems, i, 'accyear')}</span>`

        /**
         * check if it's a devon popup
         * append the acctime field
         */

        if (popupname === 'devon') {
          conterz += `<span>&nbsp;&nbsp; ${functions.getFieldValue(myitems, i, 'acctime')}</span>`
        }

        /**
         * check if it's a collisionmap website
         */

        if (window.location.href.indexOf('collisionmap') > -1) {
        /**
         * append the table with:
         * Vehs
         * Cas
         * Peds
         * Child
         * Cycles
         * OAPs
         */

          conterz += `</div><table class='coltabacc'>`
          conterz += `<tr class='back'><th colspan='4' class='coltop'>No. of</th><th colspan='3' class='coltop'>${popupconfig.accsmap_popup.casualties}</th></tr>`
          conterz += `<tr class='colbot back'><th>${popupconfig.accsmap_popup.vehs}</th><th>${popupconfig.accsmap_popup.cas}</th><th>${popupconfig.accsmap_popup.p2w}</th><th>${popupconfig.accsmap_popup.cycles}</th><th class='collef'>${popupconfig.accsmap_popup.peds}</th><th>${popupconfig.accsmap_popup.child}</th><th>${popupconfig.accsmap_popup.sixtyplus}</th></tr><tr>`
          conterz += `<td>${functions.getFieldValue(myitems, i, 'vehicles')}</td>`
          conterz += `<td>${functions.getFieldValue(myitems, i, 'casualties')}</td>`
          conterz += `<td>${functions.getFieldValue(myitems, i, 'twmv')}</td>`
          conterz += `<td>${functions.getFieldValue(myitems, i, 'cycles')}</td>`
          conterz += `<td  class='collef'>${functions.getFieldValue(myitems, i, 'pedestrian')}</td>`
          conterz += `<td>${functions.getFieldValue(myitems, i, 'children')}</td>`
          conterz += `<td>${functions.getFieldValue(myitems, i, 'oaps')}</td>`
          conterz += `</tr></table>`
        }

        /**
         * check if it's a devon popup
         */

        else if (popupname === 'devon') {
        /**
         * append the table with:
         * Vehs
         * Cas
         * Peds
         * Child
         * Cycles
         * OAPs
         */

            conterz += `</div><table class='coltabacc'>`
            conterz += `<tr class='back'><th colspan='4' class='coltop'>No. of</th><th colspan='3' class='coltop'>${popupconfig.accsmap_popup.casualties}</th></tr>`
            conterz += `<tr class='colbot back'><th data-toggle="tooltip" title="Vehicles">${popupconfig.accsmap_popup.vehs}</th><th data-toggle="tooltip" title="Casualties">${popupconfig.accsmap_popup.cas}</th><th data-toggle="tooltip" title="Powered Two Wheeler">${popupconfig.accsmap_popup.p2w}</th><th data-toggle="tooltip" title="Cycles">${popupconfig.accsmap_popup.cycles}</th><th class='collef' data-toggle="tooltip" title="Pedestrians">${popupconfig.accsmap_popup.peds}</th><th data-toggle="tooltip" title="Childrens">${popupconfig.accsmap_popup.child}</th><th data-toggle="tooltip" title="Over 60">${popupconfig.accsmap_popup.sixtyplus}</th></tr><tr>`
            conterz += `<td>${functions.getFieldValue(myitems, i, 'vehicles')}</td>`
            conterz += `<td>${functions.getFieldValue(myitems, i, 'casualties')}</td>`
            conterz += `<td>${functions.getFieldValue(myitems, i, 'twmv')}</td>`
            conterz += `<td>${functions.getFieldValue(myitems, i, 'cycles')}</td>`
            conterz += `<td  class='collef'>${functions.getFieldValue(myitems, i, 'pedestrian')}</td>`
            conterz += `<td>${functions.getFieldValue(myitems, i, 'children')}</td>`
            conterz += `<td>${functions.getFieldValue(myitems, i, 'oaps')}</td>`
            conterz += `</tr></table>`
        }

        /**
         * else if it's a standard popup
         */

        else {
        /**
         * append a span for each:
         * Vehs
         * Cas
         * Peds
         * Child
         * Cycles
         * OAPs
         */

          conterz += `</div><div><span class='infotitle'>${popupconfig.accsmap_popup.vehs}: <span class='infotitle_norm'>${functions.getFieldValue(myitems, i, 'vehicles')}</span></span>`
          conterz += `<span class='infotitle'>&nbsp;&nbsp;&nbsp; ${popupconfig.accsmap_popup.cas}: <span class='infotitle_norm'>${functions.getFieldValue(myitems, i, 'casualties')}</span></span>`
          conterz += `<span class='infotitle'>&nbsp;&nbsp;&nbsp; ${popupconfig.accsmap_popup.peds}: <span class='infotitle_norm'>${functions.getFieldValue(myitems, i, 'pedestrian')}</span></span>`
          conterz += `<span class='infotitle'>&nbsp;&nbsp;&nbsp; ${popupconfig.accsmap_popup.child}: <span class='infotitle_norm'>${functions.getFieldValue(myitems, i, 'children')}</span></span>`
          conterz += `<span class='infotitle'>&nbsp;&nbsp;&nbsp; ${popupconfig.accsmap_popup.cycles}: <span class='infotitle_norm'>${functions.getFieldValue(myitems, i, 'cycles')}</span></span>`
          conterz += `<span class='infotitle'>&nbsp;&nbsp;&nbsp; ${popupconfig.accsmap_popup.p2w}: <span class='infotitle_norm'>${functions.getFieldValue(myitems, i, 'twmv')}</span></span>`
          conterz += `<span class='infotitle'>&nbsp;&nbsp;&nbsp; ${popupconfig.accsmap_popup.oaps}: <span class='infotitle_norm'>${functions.getFieldValue(myitems, i, 'oaps')}</span></span></div>`
        }

        /**
         * check if it's a devon popup
         * append location
         */

        if (popupname === 'devon') {
          conterz += `<div><span class='infotitle'>${popupconfig.accsmap_popup.location}:</span></div>`
          conterz += `<div><span>${functions.getFieldValue(myitems, i, 'acclocation')}</span></div>`
        }

        /**
         * append the Data correct at time of publication (date) text
         */

        conterz += `<div><span>${popupconfig.accsmap_popup.datastate} <time>${functions.getPublishDate('accsmap').split('-').reverse().join('/')}<time></span></div>`

        /**
         * end if it's an accident type
         */
      }

      /**
       * copy button
       */

      conterz += `<button id='Copy_Btn_${i}' class='Copy_Btn btn mt-1 fas fa-clipboard' style='width:auto;' data-toggle="tooltip" data-container="#Copy_Btn_${i}" data-placement="top" title="${popupconfig.copystate}"></button>`

      /**
       * check if is the first iteration, first result or not
       * append the correct div to the popup content
       */

      if (i === 0) {
        infoDiv = infoDiv + `<div id='info_${i}'>${conterz}</div>`
      }
      else {
        infoDiv = infoDiv + `<div id='info_${i}' style='display:none;'>${conterz}</div>`
      }

      /**
       * reset the conterz var as now is inside the infoDiv var
       */

      conterz = ''
    } // next feature

    /**
     * end standard popup
     */
  }

  /**
   * common code for all popup
   */

  /**
   * check if the length of the result is more than 1
   */

  if (myitemsLength > 1) {
    /**
     * create the infolink variable
     *  - this is the button that display the list of all the selected restrictions
     * merge and assing infolink plus infoDiv to the content of the popup
     */

    infolink = `<div><button id='itembutton' class='custbtn itembutton_am'></button><div id='itemdiv' style='display:none'><ul id='itemlist'>${infolink}</ul></div></div>`
    conterz = infolink + infoDiv + `<input type='hidden' id='numofdivs' value='${myitemsLength}'/>`
  }

  /**
   * if the length of the result is 1
   */

  else {
    /**
     * assing infoDiv to the content of the popup
     */

    conterz = infoDiv
  }

  /**
   * check for the screen resolution
   */

  if (functions.mobileTabletView()) {
    /**
     * if is mobile append the content of the popup to the modal used for the popup
     * display the modal
     */

    modalpop.innerHTML = conterz
    $('#mobpopup').modal('show')
  }

  /**
   * if is a tablet or a pc append the content of the popup to the popup div
   * display the modal
   */

  else {
    content.innerHTML = conterz
  }

  /**
   * if you click on multiple restrictions show all the available restrictions
   */

  setInfoControls(overlay, mousePos, popupname)

  /**
   * end accspoppup
   */
}

/**
 * accsmap plus popup
 */

const accspopupplus = (xml, mousePos, getOverlay) => {
  /**
   * assign the popupname value
   * assign the overlay value
   */

   let popupname = layerinfo.popupname
   let overlay = getOverlay

   /**
    * get the result from the XML
    * - create a parser
    * - parse the result
    * - get the item element
    * - get the length of the item element
    */

    let myitems = xml.getElementsByTagName('item')
    let myitemsLength = myitems.length

  /**
   * initilaize some variable to use it in the process
   */

  let conterz = ''
  let infolink = ''
  let infoDiv = ''

  /**
   * get the popup container
   *  - normal popup
   *  - mobile popup
   */

  let content = document.getElementById('popup-content')
  let modalpop = document.getElementById('mobpopupbody')
  $('#popup').addClass('pluspop')
  /**
   * create the popup content
   */

  /**
   * iterate through the result
   */

  for (let i = 0; i <= (myitemsLength - 1); i++) {
    /**
     * check if the length of the result is more than 1
     */
     if (myitems[i].attributes.getNamedItem('type').nodeValue === 'site') {
        /**
         * check if the length of the result is more than 1
         */

        if (myitemsLength > 1) {
          /**
           * add the site name and site type to infolink
           * this will be use in the list that display all the selected restrictions
           */

          infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${popupconfig.accsmap_popup.site} ${functions.getFieldValue(myitems, i, 'sitename')}</li>`
        }

        /**
         * append the sitename and cam_dist field
         * append the equipment text an the site type
         * append data correct at time of pubblication (date) text
         */
        // dummy blank police ref to stop getvehcas
        conterz += `<span id='police_ref_${i}' style="display:none;"></span>`
        conterz += `<div><span class='infotitle'>${functions.getFieldValue(myitems, i, 'sitename')}, ${functions.getFieldValue(myitems, i, 'cam_dist')}</span></div>`
        conterz += `<div><span class='infotitle'>${popupconfig.accsmap_popup.equipment} </span><span>${functions.getFieldValue(myitems, i, 'type')}</span></div>`
        conterz += `<div><span>${popupconfig.accsmap_popup.datastate} <time>${functions.getPublishDate('accsmap').split('-').reverse().join('/')}<time></span></div>`
      }

      /**
       * check if the node is camera
       */

      else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'camera') {
        /**
         * check if the length of the result is more than 1
         */

        if (myitemsLength > 1) {
          /**
           * add the site name to infolink
           * this will be use in the list that display all the selected restrictions
           */

          infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${popupconfig.accsmap_popup.camera}${functions.getFieldValue(myitems, i, 'sitename')}</li>`
        }

        /**
         * append the sitename and cam_dist field
         * append the equipment text an the site type
         * append data correct at time of pubblication(date) text
         */
        // dummy blank police ref to stop getvehcas
        conterz += `<span id='police_ref_${i}' style="display:none;"></span>`
        conterz += `<div><span class='infotitle'>${functions.getFieldValue(myitems, i, 'sitename')}, ${functions.getFieldValue(myitems, i, 'cam_dist')}</span></div>`
        conterz += `<div><span class='infotitle'>${popupconfig.accsmap_popup.equipment} </span><span>${functions.getFieldValue(myitems, i, 'type')}</span></div>`
        conterz += `<div><span>${popupconfig.accsmap_popup.datastate} <time>${functions.getPublishDate('accsmap').split('-').reverse().join('/')}<time></span></div>`
      }

      /**
       * else if it's an accident type
       */

      else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'accident') {
        if (myitemsLength > 1) {
        /**
         * add the site name to infolink
         * this will be use in the list that display all the selected restrictions
         */

        infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'police_ref')}: ${functions.getFieldValue(myitems, i, 'severity')}</li>`
        }

        /**
         * append the severity field and collision details text
         * append the police_ref field
         * append the accday accmonth accyear and acctime
         */

        conterz += `<div><span class='infotitle'>${functions.getFieldValue(myitems, i, 'severity')} ${popupconfig.accsmap_popup.collisiondetails} </span>`
        conterz += `<span id='police_ref_${i}'>${functions.getFieldValue(myitems, i, 'police_ref')}</span>`
        conterz += ` - <time>${functions.getFieldValue(myitems, i, 'accday')} ${functions.getFieldValue(myitems, i, 'accmonth')} ${functions.getFieldValue(myitems, i, 'accyear')}</time> - <time>${functions.getFieldValue(myitems, i, 'acctime')}</time></div>`

        if (popupname === 'devonplus') {
          //add local auth code
          conterz += `<div><span class='infotitle'>Local Authority Area:</span></div>`
         if (functions.getFieldValue(myitems, i, 'local_auth') == 'TORBAY') {
              conterz += `<div><a href="https://www.torbay.gov.uk/roads/road-safety/" style="width: 109px;" aria-label="Click to navigate to Torbay Council"><img class="la-link-logo" src="${$('#docstore').val()}/custom/assets/torbay.png" alt="Torbay logo"></a></div>`
              //conterz += `<div><a class='lalink' target='_blank' rel='noopener noreferrer' href='https://www.torbay.gov.uk/roads/road-safety/'>Torbay Council</a></div>`
          } else if (functions.getFieldValue(myitems, i, 'local_auth') == 'PLYMOUTH') {
              conterz += `<div><a href="https://www.plymouth.gov.uk/road-safety" style="width: 109px;" aria-label="Click to navigate to Plymouth City Council"><img class="la-link-logo" src="${$('#docstore').val()}/custom/assets/plymouth.png" alt="Plymouth logo"></a></div>`
              //conterz += `<div><a class='lalink' target='_blank' rel='noopener noreferrer' href='https://www.plymouth.gov.uk/road-safety'>Plymouth City Council</a></div>`
          } else if (functions.getFieldValue(myitems, i, 'local_auth') == 'CORNWALL') {
              conterz += `<div><a href="https://www.cornwall.gov.uk/fire-and-rescue-service/keeping-safe/road-safety/" style="width: 150px;" aria-label="Click to navigate to Cornwall County Council"><img class="la-link-logo" src="${$('#docstore').val()}/custom/assets/cornwall.png" alt="Cornwall logo"></a></div>`
              //conterz += `<div><a class='lalink' target='_blank' rel='noopener noreferrer' href='https://www.cornwall.gov.uk/fire-and-rescue-service/keeping-safe/road-safety/'>Cornwall County Council</a></div>`
        } else if (functions.getFieldValue(myitems, i, 'local_auth') == 'NH') {
            conterz += `<div><a href="https://nationalhighways.co.uk/road-safety/" style="width: 150px;" aria-label="Click to navigate to Cornwall County Council"><img class="la-link-logo" src="${$('#docstore').val()}/custom/assets/nh.png" alt="National Highways logo"></a></div>`
            //conterz += `<div><a class='lalink' target='_blank' rel='noopener noreferrer' href='https://www.cornwall.gov.uk/fire-and-rescue-service/keeping-safe/road-safety/'>Cornwall County Council</a></div>`

          } else {
              conterz += `<div><a href="https://www.devon.gov.uk/roadsandtransport/" style="width: 150px;" aria-label="Click to navigate to Devon County Council"><img class="la-link-logo" src="${$('#docstore').val()}/custom/assets/devon.png" alt="Devon logo"></a></div>`
              //conterz += `<div><a class='lalink' target='_blank' rel='noopener noreferrer' href='https://www.devon.gov.uk/roadsandtransport/'>Devon County Council</a></div>`
          }
      }
        /**
         * append the visibilty text and field
         * append the weather text and field
         * append the road cond text and field
         */

        conterz += `<div><span class='infotitle'> ${popupconfig.accsmap_popup.visibility}</span><span>${functions.getFieldValue(myitems, i, 'visibility')}</span>`
        conterz += `<span class='infotitle'> ${popupconfig.accsmap_popup.weather}</span><span>${functions.getFieldValue(myitems, i, 'weather')}</span>`
        conterz += `<span class='infotitle'> ${popupconfig.accsmap_popup.roadcond}</span><span>${functions.getFieldValue(myitems, i, 'road_cond')}</span></div>`

        /**
         * append the 1st road text and field
         * append the 2nd road text and field
         * append the speed limit text and field
         */

        conterz += `<div><span class='infotitle'>${popupconfig.accsmap_popup.road1}</span><span>${functions.getFieldValue(myitems, i, 'roadclass1')} ${functions.getFieldValue(myitems, i, 'roadnum1')}</span>`
        conterz += `<span class='infotitle'>${popupconfig.accsmap_popup.road2}</span><span>${functions.getFieldValue(myitems, i, 'roadclass2')} ${functions.getFieldValue(myitems, i, 'roadnum2')}</span>`
        conterz += `<span class='infotitle'>${popupconfig.accsmap_popup.speedlimit}</span><span>${functions.getFieldValue(myitems, i, 'speed_lim')}</span></div>`

        /**
         * check if the popup is ssrp
         */

        if (popupname === 'ssrp') {
        /**
         * append the acclocation field
         * append the Special conditions and hazards text and field
         */

        conterz += `<div style='border-top:1px solid silver;'><span>${functions.getFieldValue(myitems, i, 'acclocation')}</span></div>`
        conterz += `<div><span class='infotitle'>${popupconfig.accsmap_popup.spcond}</span><span class='infotitle_norm'>${functions.getFieldValue(myitems, i, 'carr_haz')}</span></div>`
        }

        /**
         * else if it's a standard popup
         */

        else {
        /**
         * append the Junction Detail text and details
         * append the officer attended ? text and reportedat field
         */

        conterz += `<div><span class='infotitle'>${popupconfig.accsmap_popup.juncdetail}</span><span>${functions.getFieldValue(myitems, i, 'junct_det')}</span><span class='infotitle'>${popupconfig.accsmap_popup.junccontrol}</span><span>${functions.getFieldValue(myitems, i, 'junct_ctrl')}</span></div>`
        conterz += `<div><span class='infotitle'>${popupconfig.accsmap_popup.officerattended}</span><span>${functions.getFieldValue(myitems, i, 'reportedat')}</span></div>`

        /**
         * check if the popup is ssrp
         */

        if (popupname === 'devonplus') {
            /**
             * append the acclocation field
             * append a separator with silver border
             */

            conterz += `<div style='border-top:1px solid silver;'><span>${functions.getFieldValue(myitems, i, 'acclocation')}</span></div>`
            conterz += `<div style='border-top:1px solid silver;'><span>`

            /**
             * append the accdesc 1 2 3 4
             */

            conterz += `${functions.getFieldValue(myitems, i, 'accdesc')} ${functions.getFieldValue(myitems, i, 'accdesc2')} ${functions.getFieldValue(myitems, i, 'accdesc3')} ${functions.getFieldValue(myitems, i, 'accdesc4')}</span></div>`

            /**
             * append contributory factors
             */

            conterz += `<div><span class='infotitle'>${popupconfig.accsmap_popup.contrib}</span></div>`
            conterz += `<div><span>${functions.getFieldValue(myitems, i, 'cf1_desc').split('_').join(' ')}</span></div>`
            conterz += `<div><span>${functions.getFieldValue(myitems, i, 'cf2_desc').split('_').join(' ')}</span></div>`
            conterz += `<div><span>${functions.getFieldValue(myitems, i, 'cf3_desc').split('_').join(' ')}</span></div>`
            conterz += `<div><span>${functions.getFieldValue(myitems, i, 'cf4_desc').split('_').join(' ')}</span></div>`
            conterz += `<div><span>${functions.getFieldValue(myitems, i, 'cf5_desc').split('_').join(' ')}</span></div>`
            conterz += `<div><span>${functions.getFieldValue(myitems, i, 'cf6_desc').split('_').join(' ')}</span></div>`
        }

        /**
         * else if it's a standard popup
         */

        else {
            /**
             * append the acclocation filed with a separator with silver border
             */

            conterz += `<div style='border-top:1px solid silver;'><span>${functions.getFieldValue(myitems, i, 'acclocation')}</span></div>`
        }

        /**
         * end else if it's a standard popup
         */
        }

        /**
         * append the Vehicle and Casualty Details text
         * append the div that will contains the info, it will be populate with the getVehCas function
         */

        conterz += `<br/><span class='infotitle vehcas'>${popupconfig.accsmap_popup.vehcasdetails}</span>`
        conterz += `<div style='height:100px;background-color:#F0F0F5;overflow-y:scroll;word-wrap:break-word;' id='vehcas${functions.getFieldValue(myitems, i, 'police_ref')}'></div>`
        conterz += `<span>${popupconfig.accsmap_popup.datastate} <time>${functions.getPublishDate('accsmap').split('-').reverse().join('/')}<time></span>`

      } // end accident

    /**
     * append the Data correct at time of publication (date) text
     */


        /**
         * copy button
         */

        conterz += `<br><button id='Copy_Btn_${i}' class='Copy_Btn btn mt-1 fas fa-clipboard' style='width:auto;' data-toggle="tooltip" data-container="#Copy_Btn_${i}" data-placement="top" title="${popupconfig.copystate}"></button>`

        /**
         * check if is the first iteration, first result or not
         * append the correct div to the popup content
         */

        if (i === 0) {
        infoDiv = infoDiv + `<div id='info_${i}'>${conterz}</div>`
        }
        else {
        infoDiv = infoDiv + `<div id='info_${i}' style='display:none;'>${conterz}</div>`
        }
    /**
     * reset the conterz var as now is inside the infoDiv var
     */
    conterz = ''
  } // next feature

  /**
   * check if the length of the result is more than 1
   */

  if (myitemsLength > 1) {
    /**
     * create the infolink variable
     *  - this is the button that display the list of all the selected restrictions
     * merge and assing infolink plus infoDiv to the content of the popup
     */

    infolink = `<div><button id='itembutton' class='custbtn itembutton_am am_plus'></button><div id='itemdiv' style='display:none'><ul id='itemlist'>${infolink}</ul></div></div>`
    conterz = infolink + infoDiv + `<input type='hidden' id='numofdivs' value='${myitemsLength}'/>`
  }
  /**
   * if the length of the result is 1
   */

  else {
    /**
     * assing infoDiv to the content of the popup
     */

    conterz = infoDiv
  }

  /**
   * check for the screen resolution
   */

  if (functions.mobileTabletView()) {
    /**
     * if is mobile append the content of the popup to the modal used for the popup
     * display the modal
     */

    modalpop.innerHTML = conterz
    $('#mobpopup').modal('show')
  }

  /**
   * if is a tablet or a pc append the content of the popup to the popup div
   * display the modal
   */
  else {
    content.innerHTML = conterz
  }

  /**
   * if you click on multiple restrictions show all the available restrictions
   */

  setInfoControls(overlay, mousePos, popupname)

  getVehCas($('#police_ref_0').text())

  /**
   * end accspoppup
   */
}

/**
 * get the vehicle casualties info
 */

const getVehCas = (sAccRef) => {
  /**
   * initialize the div to send to the query
   */
  if (sAccRef === '') {return}
  let theDiv = `vehcas${sAccRef}`

  /**
   * initialize the phpfile var to empty
   * check if it's a local dev environment
   * populate the phpfile var accordingly
   */

  let jsonString = '{"accref":"' + sAccRef + '"}'
  /**
   * send an ajax request
   */
   $.ajax({
    url: '/getvehcas',
    type:"POST",
    data: {
      jdata: jsonString
    },
    beforeSend: function beforeSend(xhr) {
      xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
    },
    success: function (data) {
      /**
       * check the result
       * display or hide the div
       */

       if (data === 'none') {
        $(`#${theDiv}`).css('display', 'none')
      }
      else {
        $(`#${theDiv}`).css('display', 'block')
        $(`#${theDiv}`).html(data)
      }
    }})

}


/**
 * if you click on multiple restrictions show all the available restrictions
 */

const setInfoControls = (getOverlay, coordinate, popupname) => {
  /**
   * initialize the overlay
   */

  let overlay = getOverlay

  /**
   * get the text from the listitem_0
   * change the text of itembutton
   * prepend the arrow to the text
   */

  const theButt = $('#listitem_0').text()

  $('#itembutton').text(theButt)
  $('#itembutton').prepend("<em class='itmbtnlist fas fa-caret-right'></em>")

  /**
   * itembutton click event listener
   */

  $('#itembutton').click(function () {
    /**
     * show/hide the list of available restrictions
     * change the arrow accordingly
     */

    $('#itemdiv').slideToggle()
    $(this).children('em').toggleClass('fa-caret-right fa-caret-down')
  })

  /**
   * itemlist click event listener
   */

  $('.itemlist').click(function (e) {
    /**
     * prevent default behaviour
     */

    e.preventDefault()

    /**
     * get the value from the this item
     * get the text from the listitem_
     * change the text of itembutton
     * prepend the arrow to the text
     * show/hide the list of available restrictions
     */

    let theVal = this.value
    const theButts = $(`#listitem_${theVal}`).text()
    $('#itembutton').text(theButts)
    $('#itembutton').prepend("<em class='itmbtnlist fas fa-caret-right'></em>")
    $('#itemdiv').slideToggle()

    /**
     * change the displayed popup content
     */

    changeInfoItem(theVal)

    /**
     * end itemlist click event listener
     */
  })
} // end setInfoControls

/**
 * change the displayed popup content
 */

const changeInfoItem = (sInfoDiv) => {
  /**
   * initialize numofdivs
   * change the numofdivs to the number of element inside numofdivs
   * assign to num the lenght of numofdivs - 1 to itemLength
   */

  let numofdivs = 0
  numofdivs = parseInt(document.getElementById('numofdivs').value)
  let itemLength = numofdivs - 1

  /**
   * initialize numofdivs
   * change the numofdivs to the number of element inside numofdivs
   * assign to num the lenght of numofdivs - 1 to itemLength
   */

  for (let l = 0; l <= itemLength; l++) {
    /**
     * check if #info_ l match info_ sInfoDiv
     */

    if (document.getElementById(`info_${l}`).id === (`info_${sInfoDiv}`)) {
      /**
       * display info_ sInfoDiv
       */

      $(`#info_${sInfoDiv}`).css('display', 'block')

      /**
       * check if it's an accsmap plus site
       * call the getVehCas function
       */

      if (pageconfig.private) {
        getVehCas($('#police_ref_' + sInfoDiv).text())
      }
    }
    /**
     * if #info_ l don't match info_ sInfoDiv
     */

    else {
      /**
       * hide info_ l
       */

      $(`#info_${l}`).css('display', 'none')
    }

    /**
     * end for loop
     */
  }
}

/**
 * EXPORT
 */

export default {
  fullInfo
}
